import Head from "next/head";

import { makeApiCall } from "@lib/api/helpers";
import { getShopInShopCategoriesApi } from "@lib/api";
import ResponsiveShopBanner from "@components/ShopInShop/ResponsiveShopBanner";
import FullWidthSection from "@components/FullWidthSection";
import ShopInShopNavbar from "@components/ShopInShop/Navbar";
import ErrorPage from "@containers/ErrorPage";
import Category from "@components/ShopInShop/Category";
import Heading from "@components/Heading";
import CategoriesList from "@components/ShopInShop/CategoriesList";
import FullWidthContainer from "@components/FullWidthContainer";

const ShopInShopPage = ({
  categories,
  banners,
  menu,
  seo,
  categoriesWithChildren,
}) => {
  if (!categories) {
    return <ErrorPage layout="404" />;
  }

  const hasTopBanner =
    banners && banners.find((banner) => banner.position === "top");

  const hasBottomBanner =
    banners && banners.find((banner) => banner.position === "bottom");

  return (
    <>
      <Head>
        {seo.title && <title>{seo.title}</title>}
        {seo.description && (
          <meta name="description" content={seo.description} />
        )}
      </Head>

      {menu && (
        <FullWidthContainer>
          <nav className="bg-black leading-[50px] overflow-auto">
            <ShopInShopNavbar menu={menu} />
          </nav>
        </FullWidthContainer>
      )}

      {hasTopBanner && (
        <div className="mt-[25px] md:mt-[60] md:rounded-tr-[20px] md:rounded-bl-[20px] overflow-hidden">
          <FullWidthSection padding="p-0">
            <ResponsiveShopBanner banner={hasTopBanner} />
          </FullWidthSection>
        </div>
      )}

      <div className="mt-[25px] md:mt-[70px]">
        <Heading
          title="Categorii de produse"
          as="h2"
          classesProp="text-[24px] -tracking-[0.66px] leading-normal"
        />

        <div className="mt-[16px] md:mt-[20px]">
          <CategoriesList categories={categories} />
        </div>

        {categoriesWithChildren &&
          categoriesWithChildren.map((category) => (
            <div className="mt-[25px] md:mt-[70px]" key={category.slug}>
              <Category category={category} />
            </div>
          ))}
      </div>

      {hasBottomBanner && (
        <div className="mt-[25px] md:mt-[60] md:rounded-tr-[20px] md:rounded-bl-[20px] overflow-hidden">
          <FullWidthSection padding="p-0">
            <ResponsiveShopBanner banner={hasBottomBanner} />
          </FullWidthSection>
        </div>
      )}

      {seo?.footer_description && (
        <div
          className="mt-[20px]"
          dangerouslySetInnerHTML={{ __html: seo.footer_description }}
        />
      )}
    </>
  );
};

ShopInShopPage.getInitialProps = async (ctx) => {
  const { query } = ctx;

  const response = await makeApiCall({
    apiArgs: [{ shopName: query.shopName }],
    apiCall: getShopInShopCategoriesApi,
    returnResponse: true,
    formatResponse: (response) => response.data,
  });

  if (response && response.status) {
    const updatedReponse = { ...response };

    if (response.menu?.length === 0) {
      updatedReponse.menu = null;
    }

    if (response.categories?.length > 0) {
      const categoriesWithChildren = response.categories.filter(
        (category) => category.children?.length > 0
      );

      if (categoriesWithChildren.length !== 0) {
        updatedReponse.categoriesWithChildren = categoriesWithChildren;
      }
    }

    return {
      ...updatedReponse,
      query,
    };
  }

  return { query };
};

ShopInShopPage.pageLayout = "default";

export default ShopInShopPage;
